var obj = {
    // 设置标题
    setTitle: function (title) {
        this.bridg({
            code: 154,
            params: {
                title: title
            }
        });
    },
    bridg: function (obj) {
        if (!obj) {
            return;
        }
        // var ua = "";
        // if (typeof navigator !== "undefined") {
        //     ua = navigator.userAgent.toLowerCase();
        // }
        // if (ua.indexOf("jihai8") === -1) {
        //     return;
        // }
        var str = JSON.stringify(obj);
        if (typeof window.JHAppJs !== "undefined") {
            window.JHAppJs.runOnAppJs(str);
        } else if (typeof window.runOnAppJs !== "undefined") {
            window.runOnAppJs(str);
        } else {
            if (window.webkit && window.webkit.messageHandlers) {
                if (window.webkit.messageHandlers.JihaiMessage) {
                    window.webkit.messageHandlers.JihaiMessage.postMessage(str);
                }
            }
        }
    },
    /*
        {"jumptype":1, "code":100, "params":"id=1234", "title":"", "url":""}
        jumptype: 1代表跳客户端原生，2代表跳客户端WebView，3代表跳外部浏览器
        code:跳客户端原生需要配置，不同的跳转码代表不同的跳转页面，配合params传递参数
        title:跳转标题，可不传
        url：跳转WebView或外部浏览器，跳转地址
    */
    goWebview (data) {
        this.bridg({
            code: 300,
            params: data
        })
    },
    goRecharge (price) {
        this.bridg({
            code: 600,
            params: {
                amount: price
            }
        })
    },
    // 分享好友
    appShare: function (option) {
        var obj = {
            code: 151,
            params: {
                title: option.title,
                desc: option.desc,
                link: option.link,
                imgUrl: option.imgUrl
            }
        };
        if (option.shareType) {
            obj.params.shareType = option.shareType || "";
        };
        if (option.newsid) {
            obj.params.newsid = option.newsid || "";
        };
        this.bridg(obj);
    },
    // 全局搜索页
    goGlobalSearch (preWordHint, hotWord) {
        if (!preWordHint) {
            preWordHint = "";
        }
        if (!hotWord) {
            hotWord = "";
        }
        this.bridg({
            code: 300,
            params: {
                jumptype: 1,
                code: 529,
                params: "pre_word_hint=" + preWordHint + "&hot_word=" + hotWord
            }
        });
    },
    // 登录
    jhAppLogin: function () {
        this.bridg({
            code: 100
        })
    },
    // 赛事详情页 篮球是9，足球是164
    goMatchLive (matchid, isLqCode) {
        this.bridg({
            code: isLqCode || 164,
            params: {
                matchid: matchid
            }
        });
    },
    // 客户端比赛详情页情报
    goMatchReport (id, isLqCode) {
        this.bridg({
            code: 300,
            params: {
                code: isLqCode || 5,
                jumptype: 1,
                params: "matchId=" + id + '&tabId=2&showFollowed=1'
            }
        });
    },
    // 客户端帖子详情页
    goJHpostDetail (id) {
        this.bridg({
            code: 300,
            params: {
                code: 514,
                jumptype: 1,
                params: "id=" + id
            }
        });
    },
    // 购买成功后同步客户端
    modelPurchaseStatus () {
        this.bridg({
            code: 316
        });
    },
    appUserPage (uid) {
        this.bridg({
            code: 152,
            params: {
                uid: uid
            }
        });
    },
    goBack () {
        this.bridg({
            code: 301,
            params: {}
        });
    },
    goBackAndToast (msg) {
        this.bridg({
            code: 302,
            params: {
                message: msg
            }
        });
    },
    // 隐藏app顶部bar
    hideAppBar (show) {
        this.bridg({
            code: 313,
            params: { show: show }
        });
    },
    closeWebview (pageCount) {
        this.bridg({
            code: 306,
            params: { pageCount: pageCount || 1 }
        });
    },
    closeWebviewIos (pageCount) {
        this.bridg({
            code: 301,
            params: { pageCount: pageCount || 1 }
        });
    },
    // iOS支付
    appiosPay (fee, type) {
        this.bridg({
            code: 202,
            params: { fee: fee, type: type },
            callback: ""
        });
    },
    // iOS购买大数据
    iosBigDataPay (payinfo) {
        this.bridg({
            code: 303,
            params: {
                type: payinfo.type,
                fee: payinfo.fee,
                is_auto: payinfo.is_auto,
                productId: payinfo.productId,
                popType: 1
            }
        });
    },
    appWXPay (json) {
        this.bridg({
            code: 200,
            params: json,
            callback: "appPaycallback"
        });
    },
    // 充值通知弹唱安卓
    rechargeNotice () {
        this.bridg({
            code: 318,
            params: { isRechargePage: 1 }
        });
    },
    // 充值通知弹唱安卓
    refreshReport () {
        this.bridg({
            code: 320
            // params: { isRechargePage: 1 }
        });
    },
    bfbPay (payInfo) {
        this.bridg({
            code: 203,
            params: {
                pay_info: payInfo
            }
        });
    },
    appAliPay (str) {
        this.bridg({
            code: 201,
            params: {
                urlparams: str
            },
            callback: "appPaycallback"
        });
    },
    imgPreservation (str) {
        this.bridg({
            code: 308
            // params: {
            //     urlparams: str
            // }
        });
    },
    imgShare (str) {
        this.bridg({
            code: 312,
            params: {
                url: str
            }
        });
    },
    goLiveDetails (str) {
        this.bridg({
            code: 508,
            params: {
                id: str
            }
        });
    },
    goHaiba (id) {
        this.bridg({
            code: 300,
            params: {
                code: 508,
                jumptype: 1,
                params: `id=${id}`
            }
        });
    }
}
export default obj;
